// ✅ FINAL PERMISSION-BASED routes.js

import BidNotificationBadgeIcon from "components/Sidebar/BidNotificationBadgeIcon";
import InterviewCombinedParentIcon from "components/Sidebar/InterviewCombinedParentIcon";
import LoginApprovalBadgeIcon from "components/Sidebar/LoginApprovalBadgeIcon";
import ProfileRequestInlineBadge from "components/Sidebar/NotificationProfileRequestBadgeIcon";
import ProfileUpdateResultInlineBadge from "components/Sidebar/NotificationProfileUpdateBadgeIcon";

import Cintsessions from "layouts/Cintsessions";
import InnovateSessionsList from "layouts/InnovateSessions";
import BidList from "layouts/bids/list";
import Clients from "layouts/clients";
import ClientView from "layouts/clients/view";
import Companies from "layouts/companies";
import MorningConsultSessionsList from "layouts/morningsessions";
// import FinalStudies from "layouts/projects/final-studies";
import ProjectCountryMetrics from "layouts/projects/project-country-metrics";
import ProjectCountryVendors from "layouts/projects/project-country-vendors";
import ProjectSurveyResponses from "layouts/projects/project-survey-responses";
import ProjectsList from "layouts/projects/projects-list";
import Studies from "layouts/projects/studies";
// import StudiesPostback from "layouts/projects/studies-postback";
import StudiesUsers from "layouts/projects/studies-users";
import StudiesHits from "layouts/projects/studies/StudiesHits";
import UserHits from "layouts/projects/studies/UserHits";
import UserData from "layouts/projects/studies/UserData";
import ProjectsView from "layouts/projects/view";
import VendorProjects from "layouts/vendor-projects";
import VendorFeasibility from "layouts/vendorFeasibility";
import Vendors from "layouts/vendors";
import VendorView from "layouts/vendors/view";
import InvoiceList from "layouts/invoices/InvoiceList";
import InvoiceCreate from "layouts/invoices/InvoiceCreate";
import InvoiceView from "layouts/invoices/InvoiceView";
import InvoiceEdit from "layouts/invoices/InvoiceEdit";
import CreditNoteList from "layouts/credit-notes/CreditNoteList";
import CreditNoteCreate from "layouts/credit-notes/CreditNoteCreate";
import CreditNoteView from "layouts/credit-notes/CreditNoteView";
import CreditNoteEdit from "layouts/credit-notes/CreditNoteEdit";

import Error404 from "layouts/authentication/error/404";
import ResetIllustration from "layouts/authentication/reset-password/illustration";
import SignInIllustration from "layouts/authentication/sign-in/illustration";
import SignUpIllustration from "layouts/authentication/sign-up/illustration";

import LoginApprovalNotifications from "layouts/login-approvals";

import AddUser from "layouts/users/add";
import EditUser from "layouts/users/edit";
import UserList from "layouts/users/list";
import UserPermissionOverrides from "components/UserPermissionOverrides";
import TrashedUserList from "layouts/users/trashed";

import SettingsIcon from "examples/Icons/Settings";
import AddBranch from "layouts/branch/add";
import EditBranch from "layouts/branch/edit";
import BranchList from "layouts/branch/list";
import TrashedBranchList from "layouts/branch/trashed";
import AddRole from "layouts/roles/add";
import RolesList from "layouts/roles/list";
import RolePermissions from "layouts/roles/view";

import AddSubBranch from "layouts/subbranch/add";
import EditSubBranch from "layouts/subbranch/edit";
import SubBranchList from "layouts/subbranch/list";
import TrashedSubBranchList from "layouts/subbranch/trashed";

import AddDepartment from "layouts/departments/add";
import EditDepartment from "layouts/departments/edit";
import DepartmentList from "layouts/departments/list";
import TrashedDepartmentList from "layouts/departments/trashed";

import AddDesignation from "layouts/designations/add";
import EditDesignation from "layouts/designations/edit";
import DesignationList from "layouts/designations/list";
import TrashedDesignationList from "layouts/designations/trashed";

import AddShift from "layouts/shifts/add";
import EditShift from "layouts/shifts/edit";
import ShiftList from "layouts/shifts/list";
import TrashedShiftList from "layouts/shifts/trashed";

import ActivitySummary from "layouts/activitysummary";
import GlobalRedirects from "layouts/global-redirects";
import IdleLogs from "layouts/idel-log";
import Settingsk from "layouts/settingsk";
import InternalVendorRedirects from "layouts/vendor-redirects";

import Document from "examples/Icons/Document";
import LeaveSettingSection from "layouts/LeaveSettingSection";
import { default as BasicInformation, default as UserBasicInfo } from "layouts/NewUser";
import AttendanceSummary from "layouts/attendance/layouts/AttendanceSummary";
import Default from "layouts/dashboards/default";
import AiDataAssistant from "layouts/ai-data-assistant";
import HrPolicy from "layouts/hrletters/policy";
import AdminInterviewRequests from "layouts/interviewAdminRequest";
import InterviewEmail from "layouts/interviewEmail";
import InterviewPending from "layouts/interviewPending";
import InterviewRejected from "layouts/interviewRejected";
import InterviewRequest from "layouts/interviewRequest";
import InterviewSection from "layouts/interviewSection";
import InterviewSelected from "layouts/interviewSelected";
import InterviewShortlisted from "layouts/interviewShortlisted";
import InterviewTraining from "layouts/interviewTraining";
import LeaveSummary from "layouts/leavetracker/components/leavesummary";
import SalaryComponents from "layouts/salary/components";
import { Navigate } from "react-router-dom";

import Person from "@mui/icons-material/Person";
import UserProfile from "layouts/interviewProfile";

//testing leave
import MonthlyAttendanceReport from "layouts/monthlyattendancereport";
import StatusCountsReport from "layouts/reports/StatusCountsReport";

const routesArray = [
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in/illustration",
    component: <SignInIllustration />,
  },
  {
    type: "route",
    name: "basicinformation",
    key: "basicinformation",
    route: "/basicinformation",
    component: <BasicInformation />,
  },
  {
    type: "route",
    name: "Sign Up",
    key: "sign-up",
    route: "/authentication/sign-up/illustration",
    component: <SignUpIllustration />,
  },
  {
    type: "route",
    name: "Reset Password",
    key: "reset-password",
    route: "/authentication/reset-password/illustration",
    component: <ResetIllustration />,
  },
  {
    type: "route",
    name: "404",
    key: "error-404",
    route: "*",
    component: <Error404 />,
  },
  {
    type: "collapse",
    name: "Dashboards",
    key: "dashboards",
    icon: <Document size="12px" />,
    // collapse: [
    //     {
    //         name: "Default",
    //         key: "default",
    //         route: "/dashboards/default",
    //         component: <Default />,
    //         permissions: ["viewDashboard"],
    //     },
    // ],
    route: "/dashboards/default",
    component: <Default />,
    noCollapse: true,
    permissions: ["dashboard", "viewDashboard", "Dashboard"],
  },

  {
    type: "collapse",
    name: "AI Data Assistant",
    key: "ai-data-assistant",
    icon: <Document size="12px" />,
    route: "/ai-data-assistant",
    component: <AiDataAssistant />,
    noCollapse: true,
    permissions: ["ai_data_assistant.pages.ask.view"],
  },

  {
    type: "collapse",
    name: "Bids",
    key: "bids",
    icon: <BidNotificationBadgeIcon />,
    route: "/bids",
    component: <BidList />,
    noCollapse: true,
    permissions: ["bids.pages.list.view", "access.system.full_access"],
  },
  {
    type: "collapse",
    name: "Projects",
    key: "projects",
    icon: <Document size="12px" />,
    collapse: [
      {
        name: "All Projects",
        key: "all-projects",
        route: "/projects/list",
        component: <ProjectsList />,
        permissions: ["projects.pages.list.view", "access.system.full_access"],
      },
    ],
    permissions: ["projects.pages.list.view", "access.system.full_access"],
  },
  {
    name: "View Project",
    key: "view-projects",
    route: "/projects/view/:id",
    component: <ProjectsView />,
    permissions: ["projects.pages.list.view", "access.system.full_access"],
  },
  {
    name: "Project Country Metrics",
    key: "project-country-metrics",
    route: "/projects/:id/countries",
    component: <ProjectCountryMetrics />,
    permissions: ["projects.pages.list.view", "access.system.full_access"],
  },
  {
    name: "Project Country Vendors",
    key: "project-country-vendors",
    route: "/projects/:id/countries/:country/vendors",
    component: <ProjectCountryVendors />,
    permissions: ["projects.pages.list.view", "access.system.full_access"],
  },
  {
    name: "Project Survey Responses",
    key: "project-survey-responses",
    route: "/projects/:id/survey-responses",
    component: <ProjectSurveyResponses />,
    permissions: ["projects.survey_responses.pages.project.view", "access.system.full_access"],
  },
  {
    name: "Project Country Survey Responses",
    key: "project-country-survey-responses",
    route: "/projects/:id/countries/:country/survey-responses",
    component: <ProjectSurveyResponses />,
    permissions: ["projects.survey_responses.pages.country.view", "access.system.full_access"],
  },
  {
    name: "Project Vendor Survey Responses",
    key: "project-vendor-survey-responses",
    route: "/projects/:id/countries/:country/vendors/:vendorId/survey-responses",
    component: <ProjectSurveyResponses />,
    permissions: ["projects.survey_responses.pages.vendor.view", "access.system.full_access"],
  },
  {
    name: "Vendor Project Survey Responses",
    key: "vendor-project-survey-responses",
    route: "/vendor-projects/survey-responses",
    component: <ProjectSurveyResponses />,
    permissions: ["vendor_projects.survey_responses.pages.all.view", "access.system.full_access"],
    visibilityKey: "vendor_projects",
  },
  {
    name: "Vendor Project Code Survey Responses",
    key: "vendor-project-code-survey-responses",
    route: "/vendor-projects/:id/survey-responses",
    component: <ProjectSurveyResponses />,
    permissions: [
      "vendor_projects.survey_responses.pages.project.view",
      "access.system.full_access",
    ],
    visibilityKey: "vendor_projects",
  },
  {
    name: "Vendor Project Country Survey Responses",
    key: "vendor-project-country-survey-responses",
    route: "/vendor-projects/:id/country-wins/:countryWinId/survey-responses",
    component: <ProjectSurveyResponses />,
    permissions: [
      "vendor_projects.survey_responses.pages.country.view",
      "access.system.full_access",
    ],
    visibilityKey: "vendor_projects",
  },

  {
    type: "collapse",
    name: "Clients",
    key: "clients",
    icon: <Document size="12px" />,
    route: "/clients",
    component: <Clients />,
    noCollapse: true,
    permissions: ["clients.list.view"],
  },
  {
    name: "View Client",
    key: "view-client",
    route: "/clients/view/:id",
    component: <ClientView />,
    permissions: ["clients.view_page.view"],
  },
  {
    type: "collapse",
    name: "Company",
    key: "companies",
    icon: <Document size="12px" />,
    route: "/companies",
    component: <Companies />,
    noCollapse: true,
    permissions: ["companies.pages.list.view"],
  },
  {
    type: "collapse",
    name: "Vendors",
    key: "vendors",
    icon: <Document size="12px" />,
    route: "/vendors",
    component: <Vendors />,
    noCollapse: true,
    permissions: ["vendors.list.view"],
  },

  {
    name: "View Vendor",
    key: "view-vendor",
    route: "/vendors/view/:id",
    component: <VendorView />,
    permissions: ["vendors.view_page.view"],
  },
  {
    type: "collapse",
    name: "Vendor Projects",
    key: "vendor-projects",
    icon: <Document size="12px" />,
    route: "/vendor-projects",
    component: <VendorProjects />,
    noCollapse: true,
    permissions: ["vendor_projects.pages.list.view"],
    visibilityKey: "vendor_projects",
  },
  {
    type: "collapse",
    name: "Invoices",
    key: "invoices",
    icon: <Document size="12px" />,
    collapse: [
      {
        name: "Client Invoices",
        key: "client-invoices",
        route: "/invoices/client",
        component: <InvoiceList invoiceType="client" />,
        permissions: ["invoices.client.pages.list.view"],
      },
      {
        name: "Vendor Invoices",
        key: "vendor-invoices",
        route: "/invoices/vendor",
        component: <InvoiceList invoiceType="vendor" />,
        permissions: ["invoices.vendor.pages.list.view"],
      },
      {
        name: "Credit Notes",
        key: "credit-notes",
        route: "/credit-notes",
        component: <CreditNoteList />,
        permissions: ["credit_notes.pages.list.view"],
      },
    ],
    permissions: [
      "invoices.client.pages.list.view",
      "invoices.vendor.pages.list.view",
      "credit_notes.pages.list.view",
    ],
  },
  {
    name: "Generate Client Invoice",
    key: "generate-client-invoice",
    route: "/invoices/client/create",
    component: <InvoiceCreate />,
    permissions: ["invoices.client.pages.create.view"],
  },
  {
    name: "View Client Invoice",
    key: "view-client-invoice",
    route: "/invoices/client/:id/view",
    component: <InvoiceView invoiceType="client" />,
    permissions: ["invoices.client.pages.view.view"],
  },
  {
    name: "Edit Client Invoice",
    key: "edit-client-invoice",
    route: "/invoices/client/:id/edit",
    component: <InvoiceEdit invoiceType="client" />,
    permissions: ["invoices.client.pages.edit.view"],
  },
  {
    name: "Generate Credit Note",
    key: "generate-credit-note",
    route: "/credit-notes/create",
    component: <CreditNoteCreate />,
    permissions: ["credit_notes.pages.create.view"],
  },
  {
    name: "View Credit Note",
    key: "view-credit-note",
    route: "/credit-notes/:id/view",
    component: <CreditNoteView />,
    permissions: ["credit_notes.pages.view.view"],
  },
  {
    name: "Edit Credit Note",
    key: "edit-credit-note",
    route: "/credit-notes/:id/edit",
    component: <CreditNoteEdit />,
    permissions: ["credit_notes.pages.edit.view"],
  },
  {
    name: "View Vendor Invoice",
    key: "view-vendor-invoice",
    route: "/invoices/vendor/:id/view",
    component: <InvoiceView invoiceType="vendor" />,
    permissions: ["invoices.vendor.pages.view.view"],
  },

  {
    type: "collapse",
    name: "Roles",
    key: "roles-access",
    icon: <Document size="12px" />,
    collapse: [
      {
        name: "Create Role",
        key: "add-role",
        route: "/roles/add",
        component: <AddRole />,
        permissions: ["access.roles.create"],
      },
      {
        name: "Permissions",
        key: "role-permissions",
        route: "/roles/list",
        component: <RolesList />,
        permissions: ["access.roles.view"],
      },
    ],
    permissions: ["access.roles.view", "access.roles.create"],
  },
  {
    name: "Manage Role Permissions",
    key: "view-role-permissions",
    route: "/roles/view/:id",
    component: <RolePermissions />,
    permissions: ["access.roles.view"],
  },
  {
    name: "User Specific Permissions",
    key: "user-specific-permissions",
    route: "/users/permissions/:id",
    component: <UserPermissionOverrides />,
    permissions: ["access.users.permissions.manage"],
  },

  {
    type: "collapse",
    name: "Redirect URLs",
    key: "redirect-urls",
    icon: <Document size="12px" />,
    collapse: [
      {
        name: "Global Redirects",
        key: "global-redirects",
        route: "/global-redirects",
        component: <GlobalRedirects />,
        permissions: ["redirect_routes.pages.global_redirects.view"],
      },
      {
        name: "Internal Vendor Redirects",
        key: "internal-vendor-redirects",
        route: "/internal-vendor-redirects",
        component: <InternalVendorRedirects />,
        permissions: ["redirect_routes.pages.vendor_redirects.view"],
      },
    ],
    permissions: [
      "redirect_routes.pages.global_redirects.view",
      "redirect_routes.pages.vendor_redirects.view",
    ],
  },
  {
    type: "route",
    name: "Legacy Vendor Redirects",
    key: "legacy-vendor-redirects",
    route: "/vendor-redirects",
    component: <Navigate to="/internal-vendor-redirects" replace />,
    permissions: ["redirect_routes.pages.vendor_redirects.view"],
  },
  {
    type: "collapse",
    name: "HRMS",
    key: "hrms",
    icon: <SettingsIcon size="12px" />, // ya koi aur icon
    collapse: [
      // ---------- Branch ----------
      {
        type: "collapse",
        name: "Branch",
        key: "branches",
        icon: <Document size="12px" />,
        collapse: [
          {
            name: "New",
            key: "add-branch",
            route: "/branches/add",
            component: <AddBranch />,
            permissions: ["branch.pages.create.view"],
          },
          {
            name: "List",
            key: "branch-list",
            route: "/branches",
            component: <BranchList />,
            permissions: ["branch.pages.list.view"],
          },
          {
            name: "Trashed List",
            key: "trashed-branch-list",
            route: "/branches/trashed",
            component: <TrashedBranchList />,
            permissions: ["branch.pages.trashed.view"],
          },
        ],
        permissions: [
          "branch.pages.create.view",
          "branch.pages.list.view",
          "branch.pages.trashed.view",
        ],
      },

      // ---------- Sub Branch ----------
      {
        type: "collapse",
        name: "Sub Branch",
        key: "sub-branches",
        icon: <Document size="12px" />,
        collapse: [
          {
            name: "New",
            key: "add-sub-branch",
            route: "/sub-branches/add",
            component: <AddSubBranch />,
            permissions: ["sub_branch.pages.create.view"],
          },
          {
            name: "List",
            key: "sub-branch-list",
            route: "/sub-branches",
            component: <SubBranchList />,
            permissions: ["sub_branch.pages.list.view"],
          },
          {
            name: "Trashed List",
            key: "trashed-sub-branch-list",
            route: "/sub-branches/trashed",
            component: <TrashedSubBranchList />,
            permissions: ["sub_branch.pages.trashed.view"],
          },
        ],
        permissions: [
          "sub_branch.pages.create.view",
          "sub_branch.pages.list.view",
          "sub_branch.pages.trashed.view",
        ],
      },

      // ---------- Shift ----------
      {
        type: "collapse",
        name: "Shift",
        key: "shifts",
        icon: <Document size="12px" />,
        collapse: [
          {
            name: "New",
            key: "add-shift",
            route: "/shifts/add",
            component: <AddShift />,
            permissions: ["shift.pages.create.view"],
          },
          {
            name: "List",
            key: "shift-list",
            route: "/shifts",
            component: <ShiftList />,
            permissions: ["shift.pages.list.view"],
          },
          {
            name: "Trashed List",
            key: "trashed-shift-list",
            route: "/shifts/trashed",
            component: <TrashedShiftList />,
            permissions: ["shift.pages.trashed.view"],
          },
        ],
        permissions: [
          "shift.pages.create.view",
          "shift.pages.list.view",
          "shift.pages.trashed.view",
        ],
      },

      // ---------- Department ----------
      {
        type: "collapse",
        name: "Department",
        key: "department",
        icon: <Document size="12px" />,
        collapse: [
          {
            name: "New",
            key: "add-department",
            route: "/departments/add",
            component: <AddDepartment />,
            permissions: ["department.pages.create.view"],
          },
          {
            name: "List",
            key: "department-list",
            route: "/departments",
            component: <DepartmentList />,
            permissions: ["department.pages.list.view"],
          },
          {
            name: "Trashed List",
            key: "trashed-department-list",
            route: "/departments/trashed",
            component: <TrashedDepartmentList />,
            permissions: ["department.pages.trashed.view"],
          },
        ],
        permissions: [
          "department.pages.create.view",
          "department.pages.list.view",
          "department.pages.trashed.view",
        ],
      },

      // ---------- Designation ----------
      {
        type: "collapse",
        name: "Designation",
        key: "designation",
        icon: <Document size="12px" />,
        collapse: [
          {
            name: "New",
            key: "add-designation",
            route: "/designations/add",
            component: <AddDesignation />,
            permissions: ["designation.pages.create.view"],
          },
          {
            name: "List",
            key: "designation-list",
            route: "/designations",
            component: <DesignationList />,
            permissions: ["designation.pages.list.view"],
          },
          {
            name: "Trashed List",
            key: "trashed-designation-list",
            route: "/designations/trashed",
            component: <TrashedDesignationList />,
            permissions: ["designation.pages.trashed.view"],
          },
        ],
        permissions: [
          "designation.pages.create.view",
          "designation.pages.list.view",
          "designation.pages.trashed.view",
        ],
      },

      // ---------- User ----------
      {
        type: "collapse",
        name: "User",
        key: "users",
        icon: <Document size="12px" />,
        collapse: [
          {
            name: "New",
            key: "add-user",
            route: "/users/add",
            component: <AddUser />,
            permissions: ["users.pages.create.view"],
          },
          {
            name: "List",
            key: "user-list",
            route: "/users/list",
            component: <UserList />,
            permissions: ["users.pages.list.view"],
          },
          {
            name: "Trashed List",
            key: "trashed-user-list",
            route: "/users/trashed",
            component: <TrashedUserList />,
            permissions: ["users.pages.trashed.view"],
          },
        ],
        permissions: [
          "users.pages.create.view",
          "users.pages.list.view",
          "users.pages.trashed.view",
        ],
      },

      {
        type: "collapse",
        name: "Attendance",
        key: "attendance",
        route: "/attendance/component/attendancesummary",
        icon: <Document size="12px" />,
        component: <AttendanceSummary />,
        noCollapse: true,
        permissions: ["Attendance"],
      },
      {
        type: "collapse",
        name: "LeaveTracker",
        key: "leave-tracker",
        icon: <Document size="12px" />,
        route: "/leavetracker/components/leavesummary",
        component: <LeaveSummary />,
        noCollapse: true,
        permissions: ["LeaveTracker"],
      },
      {
        type: "collapse",
        name: "HR Letters",
        key: "hr-letters",
        icon: <Document size="12px" />,
        collapse: [
          {
            name: "Policy",
            key: "hr-policy",
            route: "/hr-letters/policy",
            component: <HrPolicy />,
            permissions: [
              "HR Policy",
              "ViewHRPolicy",
              "AddHRPolicy",
              "DeleteHRPolicy",
              "TrashedHRPolicy",
              "RestoreHRPolicy",
            ],
          },
        ],
        permissions: ["HRLetters"],
      },

      {
        type: "collapse",
        name: "Idle Logs",
        key: "idel-logs",
        route: "/idel-log",
        icon: <Document size="12px" />,
        component: <IdleLogs />,
        noCollapse: true,
        permissions: ["viewIdleLogs"],
      },
      {
        type: "collapse",
        name: "Activity Summary",
        key: "activity-summary",
        route: "/activity-summary",
        icon: <Document size="12px" />,
        component: <ActivitySummary />,
        noCollapse: true,
        permissions: ["viewActivitySummary"],
      },

      {
        type: "collapse",
        name: "Profile",
        key: "profile",
        icon: <Person size="12px" />,
        collapse: [
          {
            name: "Profile Update Request", // ✅ STRING
            key: "send-request",
            route: "/profile/send-request",
            component: <InterviewRequest />,
            permissions: ["UserProfileUpdateRequest"],
            icon: <ProfileUpdateResultInlineBadge />, // ✅ BADGE HERE
          },

          {
            name: "New Profile Update Request",
            key: "pending-request",
            route: "/profile/admin-pending-request",
            component: <AdminInterviewRequests />,
            permissions: ["AdminProfileUpdateRequest"],
            icon: <ProfileRequestInlineBadge />,
          },

          {
            name: "View Profile",
            key: "view-profile",
            route: "/profile/view-profile",
            component: <UserProfile />,
            permissions: ["MyProfile"],
          },
        ],
        permissions: ["MyProfile"],
      },

      {
        type: "collapse",
        name: "Interview",
        key: "interview",
        icon: <InterviewCombinedParentIcon />,
        icon: <Document size="12px" />,
        collapse: [
          {
            name: "Send Interview Link",
            key: "send-email",
            route: "/interview/send-email",
            component: <InterviewEmail />,
            permissions: ["InterviewSendEmail"],
          },
          {
            name: "New Arrivals",
            key: "pending",
            route: "/interview/pending",
            component: <InterviewPending />,
            permissions: ["InterviewPending"],
          },
          {
            name: "Rejected User",
            key: "rejected",
            route: "/interview/rejected",
            component: <InterviewRejected />,
            permissions: ["InterviewRejected"],
          },
          {
            name: "Shortlisted User",
            key: "shortlisted",
            route: "/interview/shortlisted",
            component: <InterviewShortlisted />,
            permissions: ["InterviewShortlisted"],
          },
          {
            name: "User on Training",
            key: "training",
            route: "/interview/training",
            component: <InterviewTraining />,
            permissions: ["InterviewTraining"],
          },
          {
            name: "Selected User",
            key: "selected",
            route: "/interview/selected",
            component: <InterviewSelected />,
            permissions: ["InterviewSelected"],
          },
          // {
          //     name: (
          //         <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
          //             <span>Profile Update Request</span>
          //             <ProfileUpdateResultInlineBadge />  {/* ✅ silent red count */}
          //         </span>
          //     ),
          //     key: "send-request",

          //     route: "/interview/send-request",
          //     component: <InterviewRequest />,
          //     permissions: ["UserProfileUpdateRequest"],
          //     icon: <span style={{ display: "none" }} />,
          // },

          {
            name: "Profile Update Request",
            key: "send-request",
            route: "/interview/send-request",
            component: <InterviewRequest />,
            permissions: ["UserProfileUpdateRequest"],
            icon: <ProfileUpdateResultInlineBadge />,
          },

          // {
          //     name: (
          //         <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
          //             <span>Profile Update Request</span>
          //             <ProfileRequestInlineBadge />  {/* ✅ silent red count */}
          //         </span>
          //     ),
          //     key: "pending-request",
          //     route: "/interview/admin-pending-request",
          //     component: <AdminInterviewRequests />,
          //     permissions: ["AdminProfileUpdateRequest"],
          //     icon: <span style={{ display: "none" }} />,
          // },

          {
            name: "New Profile Update Request",
            key: "pending-request",
            route: "/interview/admin-pending-request",
            component: <AdminInterviewRequests />,
            permissions: ["AdminProfileUpdateRequest"],
            icon: <ProfileRequestInlineBadge />,
          },
        ],
        permissions: ["Interview"],
      },

      {
        type: "collapse",
        name: "Salary",
        key: "salary",
        icon: <Document size="12px" />,
        route: "/salary/:id?",
        component: <SalaryComponents />,
        noCollapse: true,
        permissions: ["Salary"],
      },
    ],
    // Parent permission – empty so it shows if any child is accessible
    permissions: ["hrms.pages.view"],
  },

  {
    type: "collapse",
    name: "Reports",
    key: "reports",
    icon: <SettingsIcon size="12px" />,
    collapse: [
      {
        name: "Monthly Attendance Report",
        key: "monthly-attendance-report",
        route: "/reports/monthly-attendance",
        component: <MonthlyAttendanceReport />,
        permissions: ["MonthlyAttendanceReport"],
      },
      {
        name: "Client Data",
        key: "client-data-report",
        route: "/reports/client-data",
        component: <StatusCountsReport reportType="client" />,
        permissions: ["reports.client_data.view"],
      },
      {
        name: "Vendor Data",
        key: "vendor-data-report",
        route: "/reports/vendor-data",
        component: <StatusCountsReport reportType="vendor" />,
        permissions: ["reports.vendor_data.view"],
      },
      {
        name: "Survey Responses",
        key: "survey-responses-report",
        route: "/reports/survey-responses",
        component: <Studies />,
        permissions: ["reports.survey_responses.view"],
      },
    ],
    permissions: [
      "AttendanceReport",
      "reports.client_data.view",
      "reports.vendor_data.view",
      "reports.survey_responses.view",
    ],
  },

  {
    type: "route",
    name: "Edit Branch",
    key: "edit-branch",
    route: "/branches/edit/:id",
    component: <EditBranch />,
    permissions: ["branch.pages.edit.view"],
  },

  {
    type: "route",
    name: "Edit Sub Branch",
    key: "edit-sub-branch",
    route: "/sub-branches/edit/:id",
    component: <EditSubBranch />,
    permissions: ["sub_branch.pages.edit.view"],
  },

  {
    type: "route",
    name: "Edit Shift",
    key: "edit-shift",
    route: "/shifts/edit/:id",
    component: <EditShift />,
    permissions: ["shift.pages.edit.view"],
  },

  {
    type: "route",
    name: "Edit Department",
    key: "edit-department",
    route: "/departments/edit/:id",
    component: <EditDepartment />,
    permissions: ["department.pages.edit.view"],
  },

  {
    type: "route",
    name: "Edit Designation",
    key: "edit-designation",
    route: "/designations/edit/:id",
    component: <EditDesignation />,
    permissions: ["designation.pages.edit.view"],
  },

  {
    type: "route",
    name: "Edit User",
    key: "edit-user",
    route: "/users/edit/:id",
    component: <EditUser />,
    permissions: ["users.pages.edit.view"],
  },

  {
    name: "Trashed HR Policy",
    key: "hr-policy-trashed",
    route: "/hr-letters/policy/trashed",
    component: <HrPolicy isTrashed />,
    permissions: ["TrashedHRPolicy"],
  },

  // { type: "title", title: "User Section", key: "title-user-section" },

  {
    // type: "collapse",
    name: "Interview Section",
    key: "interview-section",

    route: "/user/interview-section/:id?",
    component: <InterviewSection />,
    // noCollapse: true,
  },
  {
    type: "route",
    name: "basicinformation",
    key: "basicinformation",
    route: "/basicinformation",
    component: <BasicInformation />,
  },

  {
    type: "route",
    name: "UserBasicInfo",
    key: "UserBasicInfo",
    route: "/newuser/index",
    component: <UserBasicInfo />,
  },

  // Old Final Studies page is intentionally disabled in the frontend.
  // {
  //   type: "collapse",
  //   name: "Final Ids",
  //   key: "final-studies",
  //   icon: <Document size="12px" />,
  //   route: "/final-studies/:id?",
  //   component: <FinalStudies />,
  //   noCollapse: true,
  //   permissions: ["viewFinalStudies"],
  // },

  // studies Hits

  {
    type: "collapse",
    name: "Studies Hits",
    key: "hits-studies",
    icon: <Document size="12px" />,
    activeIcon: <Document size="12px" />,
    route: "/hits/studies",
    component: <StudiesHits />,
    noCollapse: true,
    permissions: ["viewStudiesHits"],
  },
  {
    type: "collapse",
    name: "User Hits",
    key: "user-hits",
    icon: <Document size="12px" />,
    activeIcon: <Document size="12px" />,
    route: "/hits/users",
    component: <UserHits />,
    noCollapse: true,
    permissions: ["viewUserHits"],
  },
  {
    type: "collapse",
    name: "User Data",
    key: "user-data",
    icon: <Document size="12px" />,
    activeIcon: <Document size="12px" />,
    route: "/hits/user-data",
    component: <UserData />,
    noCollapse: true,
    permissions: ["user_hits.page.view", "user_hits", "viewUserHits"],
  },
  // Old Studies Postback page is intentionally disabled in the frontend.
  // {
  //   type: "collapse",
  //   name: "Studies-Postback",
  //   key: "studies-postback",
  //   icon: <Document size="12px" />,
  //   route: "/studiesPostback/:id?",
  //   component: <StudiesPostback />,
  //   noCollapse: true,
  //   permissions: ["viewStudiesPostback"],
  // },
  {
    type: "collapse",
    name: "Studies-Users",
    key: "studies-users",
    icon: <Document size="12px" />,
    route: "/StudiesUsers",
    component: <StudiesUsers />,
    noCollapse: true,
    permissions: ["StudiesUsers"],
  },

  // {
  //     type: "collapse",
  //     name: "SessionsList",
  //     key: "Morning-Consult-Sessions-List",
  //     icon: <Document size="12px" />,
  //     route: "/MorningConsultSessionsList",
  //     component: <MorningConsultSessionsList />,
  //     noCollapse: true,
  //     permissions: ["MCSesssionList"],
  // },
  // {
  //     type: "collapse",
  //     name: "Cint Sessions",
  //     key: "cint-sessions",
  //     icon: <Document size="12px" />,
  //     route: "/Session-cint-list",
  //     component: <Cintsessions />,
  //     noCollapse: true,
  //     permissions: ["CintSessions"],
  // },
  // {
  //     type: "collapse",
  //     name: "Innovate Sessions",
  //     key: "innovate-sessions",
  //     icon: <Document size="12px" />,
  //     route: "/innovate-sessions",
  //     component: <InnovateSessionsList />,
  //     noCollapse: true,
  //     permissions: ["viewInnovateSessions"],
  // },

  {
    type: "collapse",
    name: "Sessions",
    key: "sessions",
    icon: <Document size="12px" />,
    collapse: [
      {
        name: "Morning Consult",
        key: "morning-consult-sessions",
        route: "/MorningConsultSessionsList",
        component: <MorningConsultSessionsList />,
        permissions: ["MCSesssionList"],
      },
      {
        name: "Cint",
        key: "cint-sessions",
        route: "/Session-cint-list",
        component: <Cintsessions />,
        permissions: ["CintSessions"],
      },
      {
        name: "Innovate",
        key: "innovate-sessions",
        route: "/innovate-sessions",
        component: <InnovateSessionsList />,
        permissions: ["viewInnovateSessions"],
      },
    ],
    permissions: ["Sessions"], // optional (ya hata bhi sakta hai)
  },

  {
    // type: "collapse",
    name: "Leave Setting Section",
    key: "leave-setting-section",
    icon: <Document size="12px" />,
    route: "layouts/LeaveSettingSection",
    component: <LeaveSettingSection />,
    // noCollapse: true,
  },

  {
    type: "collapse",
    name: "Notifications",
    key: "login-approval-notifications",
    icon: <LoginApprovalBadgeIcon />,
    route: "/login-approval-notifications",
    component: <LoginApprovalNotifications />,
    noCollapse: true,
    permissions: ["login_approvals.pages.list.view", "login_approvals.actions.open_list"],
  },
  // {
  //     type: "collapse",
  //     name: "Leave",
  //     key: "leave-approvals",
  //     icon: <NotificationLeaveBadgeIcon />,
  //     route: "/leave/approvals",
  //     component: <LeaveApprovalTable />,
  //     noCollapse: true,
  //     permissions: ["ApproveLeave"],
  // },
  // {
  //     type: "collapse",
  //     name: "Apply Leave",
  //     key: "apply-leave",
  //     icon: <Document size="12px" />,
  //     route: "/leave/apply",
  //     component: <LeaveApplyForm />,
  //     noCollapse: true,
  //     permissions: ["ApplyLeave"],
  // },
  // {
  //     type: "collapse",
  //     name: "My Leave History",
  //     key: "leave-history",
  //     icon: <Document size="12px" />,
  //     route: "/leave/history",
  //     component: <LeaveHistory />,
  //     noCollapse: true,
  //     permissions: ["viewLeaveHistory"],
  // },
  // {
  //     type: "collapse",
  //     name: "My Breaks",
  //     key: "my-breaks",
  //     icon: <Document size="12px" />,
  //     route: "/breaks/my",
  //     component: <MyBreaks />,
  //     noCollapse: true,
  //     permissions: ["viewMyBreaks"],
  // },
  // {
  //     type: "collapse",
  //     name: "All Breaks",
  //     key: "all-breaks",
  //     icon: <Document size="12px" />,
  //     route: "/breaks/all",
  //     component: <AllBreaks />,
  //     noCollapse: true,
  //     permissions: ["viewAllBreaks"],
  // },

  {
    type: "route",
    name: "VendorFeasibility",
    key: "vendor-feasibility",
    route: "/vendor-feasibility",
    component: <VendorFeasibility />,
  },

  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: <SettingsIcon size="12px" />,
    route: "/settings",
    component: <Settingsk />,
    noCollapse: true,
    permissions: ["Settings"],
  },
  // {
  //     name: "Attendancepage",
  //     key: "attendancepage",
  //     route: "/attendancek",
  //     component: <Attendancek />,
  //     noCollapse: "true",
  //     permissions: [],
  // },
];

export const routes = routesArray;

export function getRoutes(userPermissions = [], routeVisibility = {}) {
  const isPublicAuthRoute = (route) =>
    route.route?.startsWith("/authentication") ||
    route.route?.startsWith("/newuser") ||
    route.route?.startsWith("/vendor-feasibility") ||
    route.route === "*";

  const hasPermission = (required, userPerms) => {
    //console.log("Checking permissions:", required, userPerms);
    if (!required || required.length === 0) return true;
    if (Array.isArray(required)) {
      return required.some((perm) => userPerms.includes(perm));
    }
    return userPerms.includes(required);
  };

  const hasFullAccess = userPermissions.includes("access.system.full_access");

  /* const filterRoutes = (routesList) =>
      routesList
        .filter((route) => {
          if (route.hidden) return false;
          if (isPublicAuthRoute(route)) return true;
          return hasPermission(route.permissions, userPermissions);
        })
        .map((route) => {
          const newRoute = { ...route };
          if (route.collapse) {
            newRoute.collapse = filterRoutes(route.collapse);
          }
          return newRoute;
        }); */

  const filterRoutes = (routesList) => {
    return routesList
      .filter((route) => {
        if (route.hidden) return false;
        if (isPublicAuthRoute(route)) return true;
        if (route.visibilityKey && routeVisibility[route.visibilityKey] === false) {
          return false;
        }
        if (hasFullAccess) return true;

        // 🔐 ROLE / PERMISSION CHECK
        if (!hasPermission(route.permissions, userPermissions)) {
          return false;
        }

        // 🛡️ ADMIN EXEMPT (status = exempt, session = null)
        if (hasFullAccess) {
          return true;
        }

        // 👁️ SESSION BASED VISIBILITY (NON-ADMIN)
        return true;
      })
      .map((route) => {
        const newRoute = { ...route };
        if (route.collapse) {
          newRoute.collapse = filterRoutes(route.collapse);
        }
        return newRoute;
      });
  };

  return filterRoutes(routesArray);
}
